import type { IMessage } from '@ui/components/organisms/message/message.typings';

/** Returns true only when query and post share the exact child-thread, conversation, and creator identity. */
export const isCurrentCommentThread = (
  query: { thread_id?: string; conversation_id?: string; creator_id?: string } | undefined,
  post: IMessage,
  creatorId: string,
): boolean => {
  if (!query) return false;

  return (
    query.thread_id === post.child_thread_id &&
    query.conversation_id === post.conversation_id &&
    query.creator_id === creatorId
  );
};
